export const getCallStatusLabel = (status: string) => {
  switch (status) {
    case 'COMPLETED': return '연결성공';
    case 'MISSED': return '부재중';
    case 'RINGING': return '벨울림';
    case 'INUSE': return '통화중';
    case 'BUSY': return '통화중';
    case 'NOANSWER': return '응답없음';
    case 'CANCEL': return '취소';
    default: return status;
  }
};
